import React, { useContext } from "react";
import FloatButton from "../components/ui/FloatButton";
import Metric from "../components/Metric";
import Method from "../components/Method";
import Current from "../components/Current";
import Criteria from "../components/Criteria";
import Trajectory from "../components/Trajectory";
import Forecast from "../components/Forecast";
import Concerns from "../components/Concerns";
import { theme } from "../theme";
// import { useNavigate } from "react-router-dom";
import { General } from "../tools/styles";
import calcComplete from "../tools/calcComplete";
import calcForecast from "../tools/calcForecast";
import {WatchContext} from '../WatchContext'
import handleInputChange from "../tools/handleInputChange";
import calcCurrentConcern from "../tools/calcCurrentConcern";
import calcFutureConcern from "../tools/calcFutureConcern";
import BackToDash from "../components/BackToDash";

const Hydrology = () => {
  
  // const navigate = useNavigate();

  let {hydrology, setHydrology} = useContext(WatchContext);

  const handleChange = ({ target }) => {
    
    let data = handleInputChange(hydrology, target)

    data.currentConcern = calcCurrentConcern(data)
    data.forecastLow = calcForecast(data, data.trajectLow)
    data.forecastHigh = calcForecast(data, data.trajectHigh)
    data.futureConcern = calcFutureConcern(data)
    data.complete = calcComplete(data);  

    setHydrology(data);
  };

  let topicItem = hydrology.metrics?.filter(
    (item) => item.metric === hydrology.metric
  )[0] ?? { methods: [] };
  let methods = topicItem.methods.map((item) => item.method) ?? [];

  console.log('hydrology test', hydrology)

  return (
    <General.Background backgroundColor={`${theme.colors.pdeOrange + 40}`}>
      <General.Heading color={theme.colors.pdeOrange}>Hydrology</General.Heading>
      <BackToDash/>
      <Metric
        currentValue={hydrology.metric}
        description="Description of how water moves in relation to various features of a site."
        metricArray={hydrology.metrics}
        handleChange={handleChange}
      />
      <Method
        currentValue={hydrology.method}
        methodArray={methods}
        handleChange={handleChange}
      />
      <Current
        currentValue={hydrology.currentValue}
        units={hydrology.units}
        just={hydrology.currentJust}
        handleChange={handleChange}
      />
      <Criteria
        low={hydrology.criteriaLow}
        high={hydrology.criteriaHigh}
        units={hydrology.units}
        type={hydrology.criteriaType}
        just={hydrology.criteriaJust}
        handleChange={handleChange}
      />
      <Trajectory
        low={hydrology.trajectLow}
        high={hydrology.trajectHigh}
        units={hydrology.units}
        just={hydrology.trajectJust}
        handleChange={handleChange}
      />
      <Forecast
        years={hydrology.forecastYears}
        just={hydrology.forecastJust}
        units={hydrology.units}
        forecastLow={hydrology.forecastLow}
        forecastHigh={hydrology.forecastHigh}
        handleChange={handleChange}
      />
      <Concerns
        currentConcern={hydrology.currentConcern}
        futureConcern={hydrology.futureConcern}
        metric={hydrology.metric}
      />
     <BackToDash/>
    </General.Background>
  );
};

export default Hydrology;
